import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const ConfirmDialog = ({
  title,
  message,
  confirmLabel,
  cancelLabel,
  isConfirming = false,
  onConfirm,
  onCancel,
}) => {
  const { t } = useLanguage();
  const finalConfirmLabel = confirmLabel || t("common.delete");
  const finalCancelLabel = cancelLabel || t("common.cancel");
  return (
  <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/30 px-4 py-6 backdrop-blur-sm">
    <div className="w-full max-w-md overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-2xl">
      <div className="flex items-start justify-between gap-4 border-b border-gray-100 px-6 py-5">
        <div className="flex gap-3">
          <span className="inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-50 text-red-600">
            <AlertTriangle className="h-5 w-5" />
          </span>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
            <p className="mt-1 text-sm leading-6 text-gray-600">{message}</p>
          </div>
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="rounded-full p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9B30FF] focus-visible:ring-offset-2"
          aria-label={t("common.close")}
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="flex justify-end gap-3 px-6 py-4">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-full border border-gray-200 bg-white px-5 py-2.5 text-sm font-semibold text-gray-800 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9B30FF] focus-visible:ring-offset-2"
        >
          {finalCancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={isConfirming}
          className="rounded-full bg-red-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
        >
          {isConfirming ? t("common.deleting") : finalConfirmLabel}
        </button>
      </div>
    </div>
  </div>
  );
};

export default ConfirmDialog;
